export interface RecordingControlVisibilityState {
  isRecording: boolean;
  isInitializing: boolean;
  isPaused: boolean;
  isFinalizingTranscription: boolean;
  hasContent: boolean;
}

export const shouldShowCompactRecordingControl = ({
  isRecording,
  isInitializing,
  isPaused,
  isFinalizingTranscription,
  hasContent,
}: RecordingControlVisibilityState): boolean =>
  isRecording || isInitializing || isPaused || isFinalizingTranscription || hasContent;
